<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >

    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbFsoLead"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>

      <BContainer>
        <BRow
          class="py-2"
        >

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="tableLeads.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(tableLeads.options.clusters)"
                :disabled="(tableLeads.busy)"
                :calculate-position="calculateDropPosition"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="tableLeads.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbFsoLead
                variant="primary"
              >
                <i
                  v-if="[].some(isTrue => isTrue)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
      <BCol
        cols="12"
        class="d-flex flex-row justify-content-between align-items-center gap-2"
      >
        <BButton
          size="sm"
          variant="primary"
          label-for="filterIsCreatedByMe"
          @click.prevent="createLead"
        >
          Add Lead
        </BButton>
      </BCol>
    </BRow>

    <CustomTable
      ref="tableLeads"
      class="no-column-before"
      :provider="tableProvider"
      :fields="tableLeads.fields"
      :filter="tableLeads.filter"
      :filter-on="tableLeads.filterOn"
      :sort-by="tableLeads.sortBy"
      :sort-desc="tableLeads.sortDesc"
      :sort-direction="tableLeads.sortDirection"
      :total-rows="tableLeads.totalRows"
      :current-page="tableLeads.currentPage"
      :per-page="tableLeads.perPage"
      :stacked="tableLeads.stacked"
      :busy="tableLeads.busy"
    >
      <template #cell(action)="{ item }">
        <div class="w-100 text-md-nowrap d-flex justify-content-md-center justify-content-end">
          <BButton
            size="sm"
            variant="primary"
            :disabled="tableLeads.busy"
            :to="{
              name: 'fso.leads.profile',
              params: {
                lead: item.id
              }
            }"
          >
            Manage
          </BButton>
        </div>
      </template>

      <template #cell(lead_name)="{ item }">
        <div class="d-flex flex-column gap-1 p-1">
          <div class="font-weight-bolder">
            {{ item.lead_name }}
          </div>
          <div style="font-size: 10px;">
            {{ item.address || 'n/a' }}
          </div>
        </div>
      </template>
    </CustomTable>

    <BModal
      ref="modalLead"
      size="lg"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <div class="px-2">
        <LeadInformations
          ref="leadInformations"
          :editing="state.editing"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <BButton
          variant="primary"
          :disabled="state.busy || isFetchingInformationLocations()"
          @click.prevent="validateLead"
        >
          {{ state.editing ? 'Update' : 'Register' }} Lead
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import { setTableOptions, getTableOptions } from '@/forage/fso/leads'
import { getClusters } from '@/forage/shared/clusters'

import LeadInformations from '@/views/fso/lead-management/Informations.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'

import { SFSOLead } from '@/services/fso'

export default {

  name: 'VFSOLeads',

  components: {
    LeadInformations
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      getClusters().then(
        clusters => {
          navigate(context => {
            if (context.currentUser) {
              if (clusters) {
                context.tableLeads.options.clusters = clusters
              }

              if (options) {
                const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

                context.tableLeads = Object.assign(context.tableLeads, {
                  totalRows: totalRows || 0,
                  sortBy: sortBy || 'id',
                  sortDesc: sortDesc || false,
                  perPage: perPage || 10,
                  currentPage: currentPage || 0,
                  filter: {
                    search: filter.search || '',
                    cluster: ''
                  }
                })

                context.tableLeads.selected.cluster = clusters.find(
                  cluster => String(cluster.id) === String(filter?.cluster || '')
                ) || ''
              } else {
                context.tableLeads.currentPage = 1
              }
            }
          })
        }
      )
    })
  },

  middleware: [
    'auth',
    'fso'
  ],

  metaInfo: () => ({
    title: 'Leads'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      tableLeads: {
        busy: false,
        options: {
          clusters: [],
          statuses: ['All', 'New', 'Verified']
        },
        selected: {
          cluster: '',
          tagging: 1
        },
        filter: {
          search: '',
          cluster: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-right stacked-full text-md-center' },
          { mobile: 3, key: 'action', class: 'text-md-center w-md-125px' },
          { mobile: 1, key: 'cluster.cluster_name', label: 'Cluster', class: 'min-w-md-150px' },
          { mobile: 2, key: 'lead_name', label: 'Lead', class: 'min-w-md-250px', sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })

    // settingFilters () {
    //   const hasEditables = Object.keys(this.tableLeads.editable).map(
    //     editableKey => this.tableLeads.editable[editableKey]
    //   ).some(val => String(val) !== '')
    //   return hasEditables
    // }
  },

  watch: {
    'tableLeads.selected.cluster' (cluster) {
      this.tableLeads.filter.cluster = cluster?.id || ''
    }
  },

  methods: {

    isFetchingInformationLocations () {
      if (this.$refs.leadInformations?.fetching) {
        const fetching = this.$refs.leadInformations.fetching
        return fetching?.provinces || fetching?.municipalities || fetching?.barangays
      }

      return false
    },

    leadStatus (status) {
      switch (status) {
        case 'Verified': {
          return 'secondary'
        }
        case 'New': {
          return 'primary'
        }
        default: {
          return 'warning'
        }
      }
    },

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableLeads.busy = true

      const payload = {
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        cluster_id: filter.cluster
      }

      return await SFSOLead.get(payload).then(
        ({ data }) => {
          this.tableLeads.totalRows = data.total_rows
          setTableOptions({
            currentPage,
            perPage,
            sortBy,
            sortDesc,
            filter,
            totalRows: data.total_rows
          })
          return data.items
        }
      ).catch(() => {
        setTableOptions({
          currentPage,
          perPage,
          sortBy,
          sortDesc,
          filter,
          totalRows: 0
        })
        this.tableLeads.totalRows = 0
        return []
      }).finally(() => {
        this.tableLeads.busy = false
      })
    },

    createLead () {
      this.state.editing = false

      this.$refs.modalLead.show()
      this.$refs.modalLead.onAfterEnter = () => {
        this.$refs.leadInformations.createInformation()
      }
    },

    validateLead () {
      this.$refs.leadInformations.submitInformation().then(
        ({ value }) => {
          if (value?.lead) {
            this.swalConfirm({
              html: 'Navigate to Lead Profile to Add More Information?',
              confirmButtonText: 'Navigate',
              cancelButtonText: 'Stay on Page',
              preConfirm: () => {
                this.$router.push({
                  name: 'fso.leads.profile',
                  params: {
                    lead: value.lead.id
                  }
                })
              }
            }).then(
              ({ isDismissed }) => {
                if (isDismissed) {
                  this.$refs.modalLead.hide()
                  this.$refs.tableLeads.refetch()
                }
              }
            )
          }
        }
      )
    }
  }
}
</script>
